import { combineReducers, configureStore } from "@reduxjs/toolkit";

import authSlice from "../slices/authSlice";
import categoryDataSlice from "../slices/categoryDataSlice";
import dashboardSlice from "../slices/dashboardSlice";
import eventSlice from "../slices/eventSlice";
import loginSlice from "../slices/loginSlice";
import marketingSlice from "../slices/marketingSlice";
import notificationSlice from "../slices/notificationSlice";
import seoSlice from "../slices/seoSlice";
import UserManagementSlice from '../slices/UserManagementSlice';
import subCategorySlice from "../slices/subCategorySlice";
import citySlice from '../slices/citySlice'
import tenantSlice from "../slices/tenantSlice";
import twilioSlice from "../slices/twilioSlice";
import rewardSlice from "../slices/rewardSlice";
import storySlice from "../slices/storySlice";
import companyAndBrandSlice from "../slices/companyAndBrandSlice";
import productSlice from "../slices/productSlice";
import couponSlice from "../slices/couponSlice";
import orderSlice from "../slices/orderSlice";
import adminNotifictionSlice from "../slices/adminNotifictionSlice";

const combinedReducer = combineReducers({
  auth: authSlice,
  login: loginSlice,
  notification: notificationSlice,
  tenant: tenantSlice,
  dashboard:dashboardSlice,
  reward: rewardSlice,
  companyBrand: companyAndBrandSlice,
  product: productSlice,
  coupon: couponSlice,
  order: orderSlice,
  story: storySlice,
  marketing: marketingSlice,
  seo: seoSlice,
  users: UserManagementSlice,
  adminNotification: adminNotifictionSlice,
  
  event: eventSlice,
  twilio: twilioSlice,
  categoryData: categoryDataSlice,
  subCategory: subCategorySlice,
  city: citySlice,
});

const rootReducer = (state, action) => {
  if (action.type === "login/setLoginFlag") {
    // check for action type
    state = undefined;
  }
  return combinedReducer(state, action);
};

const store = configureStore({
  reducer: rootReducer,
});

export default store;
